import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './utils/router'
import { useUIStore } from './utils/store'
import CommunityChat from './components/CommunityChat'
import PwaInstallGuide from './components/PwaInstallGuide'
import AppErrorBoundary from './components/AppErrorBoundary'
import './styles/index.css'

// 加载中组件
function LoadingFallback() {
  return (
     <div style={{
      width: '100vw',
      height: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
      color: 'var(--color-text-secondary)',
     }}>
      加载中...
     </div>
   )
}

// 主应用组件
function App() {
  const theme = useUIStore((state) => state.theme)

  return (
     <div className={`app app--${theme}`}>
       <AppErrorBoundary>
         <Suspense fallback={<LoadingFallback />}>
           <RouterProvider router={router} />
         </Suspense>
       </AppErrorBoundary>
       <CommunityChat />
       <PwaInstallGuide />
     </div>
   )
}

// 应用入口
export default App
